import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, Box, Divider, Typography, CircularProgress
} from '@mui/material';
import { setupInterceptorsTo } from "../Componentes/API/AxiosBuilder";
import axios from 'axios';
import { URL_API_SIA } from "../Contantes/Constantes";
import { useBody } from "../Body/state/BodyContext";
import { TreeView, TreeItem } from '@mui/x-tree-view';

const buildIncidenciaTree = (incidencias) => {
    const map = new Map();
    const raiz = [];

    incidencias.forEach((i) => {
        map.set(i.id, { ...i, hijos: [] });
    });

    map.forEach((item) => {
        if (item.id_padre && map.has(item.id_padre)) {
            map.get(item.id_padre).hijos.push(item);
        } else {
            raiz.push(item);
        }
    });

    return raiz;
};


const renderTreeItem = (inc) => (
    <TreeItem itemId={String(inc.id)} label={inc.contenido || `Incidencia ${inc.id}`} key={inc.id}>
        {inc.hijos && inc.hijos.map((h) => renderTreeItem(h))}
    </TreeItem>
);

const ModalFormularioIncidencia = ({ open, onClose, incidenciasPadre = [] }) => {
    const [contenido, setContenido] = useState('');
    const [padre, setPadre] = useState('');
    const [errorContenido, setErrorContenido] = useState(false);
    const [loading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState([]);
    const axiosInstance = setupInterceptorsTo(axios.create());

    const handleToggle = (event, nodeIds) => {
        if (!event.target.closest('.MuiTreeItem-iconContainer')) return;
        setExpanded(nodeIds);
    };
    const renderTreeItemOld = (inc) => (
        <TreeItem nodeId={String(inc.id)} label={inc.contenido || `Incidencia ${inc.id}`} key={inc.id}>
            {inc.hijos && inc.hijos.map((h) => renderTreeItemOld(h))}
        </TreeItem>
    );

    const handleSubmit = async () => {
        if (contenido.trim() === '') {
            setErrorContenido(true);
            return;
        }

        const nuevaIncidencia = {
            contenido: contenido,
            id_padre: padre || null,
        };

        try {
            setLoading(true);
            const response = await axiosInstance.post(`${URL_API_SIA}/chatbot/incidencia`, nuevaIncidencia);
            if (response.data.success) {
                // mostrar mensaje si querés
            }
            resetForm();
            onClose();
        } catch (error) {
            console.error('Error al enviar la incidencia:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    const resetForm = () => {
        setContenido('');
        setPadre('');
        setErrorContenido(false);
    };

    const treeData = buildIncidenciaTree(incidenciasPadre);

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>
                <Typography variant="h5" component="p">Crear Nueva Incidencia</Typography>
            </DialogTitle>
            <Divider sx={{ width: '92%', mx: 'auto' }} />

            <DialogContent>
                <Box display="flex" flexDirection="column" gap={3} mt={1}>
                    <TextField
                        label="Contenido"
                        fullWidth
                        multiline
                        minRows={4}
                        value={contenido}
                        onChange={(e) => {
                            setContenido(e.target.value);
                            if (e.target.value.trim() !== '') setErrorContenido(false);
                        }}
                        error={errorContenido}
                        helperText={errorContenido ? 'Este campo es obligatorio.' : ''}
                    />

                    <Typography variant="subtitle1">Incidencia Padre</Typography>
                    <Box
                        sx={{
                            border: '1px solid rgba(0, 0, 0, 0.23)',
                            borderRadius: 1,
                            padding: 1,
                            maxHeight: 300,
                            overflowY: 'auto',
                        }}
                    >

                        <TreeView
                            expanded={expanded}
                            onNodeToggle={handleToggle}
                            selected={padre !== undefined ? [String(padre)] : []}
                            onNodeSelect={(event, nodeId) => {
                                setPadre(nodeId);
                            }}
                            defaultExpandIcon={<span>▶</span>}
                            defaultCollapseIcon={<span>▼</span>}
                        >

                        <TreeItem nodeId="" label={<em>Ninguna</em>} />
                            {treeData.map((inc) => renderTreeItemOld(inc))}
                        </TreeView>


                    </Box>
                </Box>
            </DialogContent>

            <DialogActions sx={{ justifyContent: 'center', gap: 2, padding: 2 }}>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                >
                    Crear
                </Button>
                <Button onClick={handleClose} color="secondary" disabled={loading}>
                    Cancelar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ModalFormularioIncidencia;
